import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import once from '@mailobj-browser/front/js/events/options/once.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import mouseMove from '@mailobj-browser/front/js/events/types/mouseMove.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import wait from '@mailobj-browser/front/js/utils/wait.js'
import { close } from '#utilities/js/lightboxes/menus/dropdown.js'
import { elements, modifiers } from '../../../styles.js'

const onMouseMove = object(listener, {
  type: mouseMove,
  once,
  passive,
  task: async (
    element
  ) => {
    const controls = one(`.${elements.meet_controls}`, element)

    controls.classList.add(modifiers.meet_controls.visible)
    await wait(5000)

    controls.classList.remove(modifiers.meet_controls.visible)
    close()
    onMouseMove.listen(element)
  }
})

export default element => {
  onMouseMove.listen(element)
}